import React, { useState } from "react";

import { auth } from "../../../Firebase/firebase";
import { priceFormater } from "../../Utility/Utility";
import classes from "./DealerPost.module.css";
import camera from "../../../assets/svg/camera.svg";
import heart from "../../../assets/svg/balckHeart.svg";
import redHeart from "../../../assets/svg/redHeart.svg";
import carImg from "../../../assets/Img/carIMg.png";
import doubleQoute from "../../../assets/Img/doubleQoute.png";
import HeartSpin from "../../UI/spinner/HeartSpin";

const DealerPosts = (props) => {
    const [currentItemWishing, setCurrentItemWishing] = useState(null);
    let dealerPosts = null;

    const checkItemIsWishLIsted = (itemId) => {
        let isWishItem = false;
        let wishArray = localStorage.getItem('myWish');
        if (props.user && props.wishIdsArray && wishArray) {
            wishArray = wishArray.split(',');
            isWishItem = wishArray.some((id) => {
                return +id === itemId
            })
        }
        return isWishItem
    };

    const addItmeToWishList = (itemId, userIsAuth) => {
        if (!props.user) {
            props.showAuthHandler('signIn')
        }
        else {
            const itemIsWishListed = checkItemIsWishLIsted(itemId);
            if (!itemIsWishListed) {
                let token = localStorage.getItem('idToken')
                if (!token) {
                    const fireUser = auth.currentUser
                    if (fireUser) {
                        fireUser.getIdToken().then(newToken => {
                            token = newToken
                            props.AddItemToWishList(itemId, token)
                        })
                    }
                    else {
                        console.log(fireUser)
                    }
                }
                else {
                    props.AddItemToWishList(itemId, token)
                }
            }
            else {
                console.log(itemId, userIsAuth, 'in my WishList')
            }
        }
    };

    if (props.dealerPosts) {
        if (props.dealerPosts.data.length === 0) {
            dealerPosts = <div className={classes.NoPosts}>
                No posts currently
            </div>
        }
        else {
            dealerPosts = props.dealerPosts.data.map(post => {
                let mediaImg = carImg;
                let isWishItem = false;
                let wishArray = localStorage.getItem('myWish');

                if (post.media.length !== 0) {
                    try {
                        mediaImg = post.media.filter(img => {
                            if (img.name === "video") {
                                return { url: "https://storage.googleapis.com/pcari-71145.appspot.com/media/png/HwN1Eapr6U.png" }
                            }
                            return img.name === 'front';
                        })[0].url;
                    } catch (error) {
                        mediaImg = post.media[0].url
                    }
                }

                if (props.user && props.wishIdsArray && wishArray) {
                    wishArray = wishArray.split(',');
                    isWishItem = wishArray.some((id) => {
                        return +id === post.id
                    })
                }
                const tailer = mediaImg.slice(-4);

                return (
                    <div className={classes.ListViewItem} key={post.id} >
                        <div className={classes.itemImage}>
                            <div className={classes.positioningCamera}>
                                <img src={camera} alt='num' /><small>{post.media.length} +</small>
                            </div>
                            {tailer === '.mp4' ?
                                <video width='100%' height='200px'>
                                    <source src={mediaImg} type='video/mp4' />
                                </video>
                                :
                                <img src={mediaImg} alt='car images' />
                            }
                            {props.addingItem && currentItemWishing === post.id ?
                                <div className={classes.AddingWish}>
                                    <HeartSpin />
                                </div>
                                :
                                <div
                                    className={classes.positioningHeart}
                                    onClick={() => {
                                        setCurrentItemWishing(post.id)
                                        addItmeToWishList(post.id, props.user !== null)
                                    }}>
                                    <img src={isWishItem ? redHeart : heart} alt='num' />
                                </div>
                            }
                        </div>
                        <div className={classes.ItemInfo}
                            onClick={(event) => {
                                props.routProp.history.push(`/Detail?vehicle=${post.id}`)
                            }}>
                            <h1>{post.title}</h1>
                            <div className={classes.Info}>
                                <div className={classes.SellerPitch}>
                                    <img src={doubleQoute} alt='' />
                                    <p>Seller's Picthc </p>
                                    {post.seller_pitch}
                                </div>
                                <div className={classes.ItemDetails}>
                                    <div className={classes.DetailsRow}>
                                        <p className={classes.Btn}>{post.condition}</p>
                                        {post.is_featured ? <p className={classes.Btn}>Featured</p> : null}
                                        <p className={classes.Btn}>{post.body_type}</p>
                                    </div>
                                    <div className={`${classes.DetailsRow} ${classes.Light}`}>
                                        <p>Driven :</p>
                                        <p>Origin :</p>
                                        <p>Transmission :</p>
                                    </div>
                                    <div className={`${classes.DetailsRow} ${classes.Dark}`}>
                                        <p>{post.driven_wheel}</p>
                                        <p>{post.origin}</p>
                                        <p>{post.transmission}</p>
                                    </div>
                                    <div className={`${classes.DetailsRow} ${classes.Light}`}>
                                        <p>Fuel :</p>
                                        <p>Mileage :</p>
                                        <p>Location :</p>
                                    </div>
                                    <div className={`${classes.DetailsRow} ${classes.Dark}`}>
                                        <p>{post.fuel_type}</p>
                                        <p>{post.mileage}</p>
                                        <p>{post.state ? post.state.name : null}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={classes.Price}>
                            <button className={classes.BtnBig}>
                                RM {priceFormater(post.price)}
                        </button>
                        </div>
                    </div>
                );
            }
            )
        }
            
        }
        return (
            <div className={classes.Container}>
                {dealerPosts}
            </div>
        );
    };

    export default DealerPosts;